module.exports = __webpack_public_path__ + "static/media/consultorio-03.a779bb1c.JPG";